import axios from 'axios'
import { useRouter } from 'vue-router'
import { deleteCookie, getCookie } from './cookie'

const router = useRouter()

export const logout = async () => {
	localStorage.removeItem('temp-user');
	localStorage.removeItem('location')

	try {
		const axiosConfig = {
			headers: {
				Authorization: `Bearer ${getCookie('accessToken')}`,
			},
		}
		deleteCookie('accessToken')
		deleteCookie('refreshToken')
		deleteCookie('access_token')
		deleteCookie('csrftoken')
		deleteCookie('sessionid')
		// @ts-ignore
		await axios.post('/api/auth/logout/', {}, axiosConfig)
	} catch (error) {
		console.log(error);
	}
	deleteCookie('accessToken')
	deleteCookie('refreshToken')
	deleteCookie('access_token')
	deleteCookie('csrftoken')
	deleteCookie('sessionid')

	localStorage.removeItem('temp-user');

	location?.replace?.('/')
	router?.push?.('/')
}

const protectedRoutes = [
	'/auth/login/',
	'/auth/check/',
	'/auth/resend/',
	'/auth/registration/',
	'/auth/logout/',
	'/profile/my/',
	'/notifications/',
	'/dashboard/media/',
	'/dashboard/',
	'/profile/certificates/',
].join('  ');

function isPublicRoute(url: string) {
	return protectedRoutes?.includes?.(url);
}

const HTTPClientPlugin = {
	install(app: any, options: any) {
		const instance = axios.create({
			baseURL: options.baseUrl,
			maxRedirects: 0,
		})

		instance.interceptors.request.use((config) => {
			const temp_user = JSON.parse(localStorage.getItem('temp-user') || "{}");

			if (temp_user?.first_name != null) {
				config.headers['Finger-Print'] = encodeURI(`${temp_user?.first_name} ${temp_user?.last_name}`);
			} else if (getCookie('accessToken')) {
				config.headers.Authorization = `Bearer ${getCookie('accessToken')}`;
			}

			return config
		})

		instance.interceptors.response.use((config) => {
			return config
		}, async (error) => {
			// const originalRequest = error.config
			if ((error.response?.status === 401 || error.response?.status === 403) && Boolean(error.config)) {
				if (isPublicRoute(error?.response?.config?.url ?? error?.request?.responseURL)) return;
				console.log('error', error);
				logout()
				throw error
			} else {
				// return await instance.request(originalRequest)
				return error
			}
		})

		app.provide('http_client', instance)
	},
}

export { HTTPClientPlugin as http_client }
